import { call, put, takeLatest } from "redux-saga/effects";
import {
  RequestContainerService,
  SuccessContainerService,
  FailureContainerService,
  RequestLiveResponsibles,
  SuccessLiveResponsibles,
  FailureLiveResponsibles,
  RequestContainerServices,
  SuccessContainerServices,
  FailureContainerServices,
  RequestInforService,
  SuccessInforService,
  FailureInforService,
  RequestVirshService,
  SuccessVirshService,
  FailureVirshService,
  RequestPodUpdate,
  SuccessPodUpdate,
  FailurePodUpdate,
  RequestPodRestart,
  SuccessPodRestart,
  FailurePodRestart,
  RequestGetAutoUpdateState,
  SuccessGetAutoUpdateState,
  FailureGetAutoUpdateState,
  RequestSetAutoUpdateState,
  SuccessSetAutoUpdateState,
  FailureSetAutoUpdateState,
  RequestBackendServiceConnected,
  SuccessBackendServiceConnected,
  FailureBackendServiceConnected,
  RequestUserServiceConnected,
  SuccessUserServiceConnected,
  FailureUserServiceConnected,
  RequestCheckExistingResponsibles,
  SuccessCheckExistingResponsibles,
  FailureCheckExistingResponsibles,
} from "../actions/containerActions";
import { addNotification } from "../actions/notifierActions";

import axiosApi from "../../utils/axios";

export function* containerService({ payload: responsible }) {
  try {
    const response = yield call(axiosApi.get, `/api/containers/service/${responsible}`);
    yield put(SuccessContainerService(response.data));
  } catch (e) {
    yield put(FailureContainerService());
  }
}

export function* liveResponsibles() {
  try {
    const response = yield call(axiosApi.get, "/api/containers/live-responsibles");
    const mailGatewayResponsibles = [];
    const networkDefenderResponsibles = [];
    const appResponsibles = [];
    const coreResponsibles = [];
    const tHunterReporterResponsibles = [];
    response.data.forEach((responsible) => {
      if (responsible?.startsWith("pf-")) mailGatewayResponsibles.push(responsible);
      else if (responsible?.startsWith("sq-")) networkDefenderResponsibles.push(responsible);
      else if (responsible?.startsWith("bk-")) appResponsibles.push(responsible);
      else if (responsible?.startsWith("an-")) coreResponsibles.push(responsible);
      else if (responsible?.startsWith("ag-")) tHunterReporterResponsibles.push(responsible);
    });
    yield put(
      SuccessLiveResponsibles({
        mailGateway: mailGatewayResponsibles,
        networkDefender: networkDefenderResponsibles,
        app: appResponsibles,
        core: coreResponsibles,
        tHunterReporter: tHunterReporterResponsibles,
      }),
    );
  } catch (e) {
    yield put(FailureLiveResponsibles());
  }
}

export function* containerServices() {
  try {
    const response = yield call(axiosApi.get, "/api/containers/services");
    yield put(SuccessContainerServices(response.data));
  } catch (e) {
    yield put(FailureContainerServices());
  }
}

export function* inforService({ payload: responsible }) {
  try {
    const response = yield call(axiosApi.get, `/api/containers/systeminfor/${responsible}`);
    yield put(SuccessInforService(response.data));
  } catch (e) {
    yield put(FailureInforService());
  }
}

export function* virshService({ payload: responsible }) {
  try {
    const response = yield call(axiosApi.get, `/api/containers/virshinfor/${responsible}`);
    yield put(SuccessVirshService(response.data));
  } catch (e) {
    yield put(FailureVirshService());
  }
}

export function* backendServiceConnected() {
  try {
    yield call(axiosApi.get, "/api/hello");
    yield put(SuccessBackendServiceConnected());
  } catch (e) {
    yield put(FailureBackendServiceConnected());
  }
}

export function* podUpdate({ payload }) {
  const { responsible, imageName, podName } = payload;
  try {
    yield call(axiosApi.get, `/api/containers/update/${responsible}/${imageName}/${podName}`);
    yield put(SuccessPodUpdate());
    yield put(
      addNotification({
        message: "Update request is successful",
        options: { variant: "success" },
      }),
    );
    yield call(backendServiceConnected);
  } catch (e) {
    yield put(FailurePodUpdate());
    yield put(
      addNotification({
        message: e?.response?.data?.message,
        options: { variant: "error" },
        time: 3000,
      }),
    );
  }
}

export function* podRestart({ payload }) {
  const { responsible, podName } = payload;
  try {
    yield call(axiosApi.get, `/api/containers/restart/${responsible}/${podName}`);
    yield put(SuccessPodRestart());
    yield put(
      addNotification({
        message: "Restart request is successful",
        options: { variant: "success" },
      }),
    );
    yield call(backendServiceConnected);
    yield call(containerService, { payload: responsible });
  } catch (e) {
    yield put(FailurePodRestart());
    yield put(
      addNotification({
        message: e?.response?.data?.message,
        options: { variant: "error" },
        time: 3000,
      }),
    );
  }
}

export function* getAutoUpdateState({ payload: responsible }) {
  try {
    const response = yield call(axiosApi.get, `/api/containers/get-auto-update/${responsible}`);
    yield put(SuccessGetAutoUpdateState(response.data.is_active));
  } catch (e) {
    yield put(FailureGetAutoUpdateState());
    yield put(
      addNotification({
        message: "Getting auto update status failed",
        options: { variant: "error" },
        time: 3000,
      }),
    );
  }
}

export function* setAutoUpdateState({ payload }) {
  const { responsible, state } = payload;
  try {
    yield call(axiosApi.get, `/api/containers/set-auto-update/${responsible}/${state}`);
    yield put(SuccessSetAutoUpdateState());
    yield call(getAutoUpdateState, { payload: responsible });
  } catch (e) {
    yield put(FailureSetAutoUpdateState());
    yield put(
      addNotification({
        message: "Setting auto update status failed",
        options: { variant: "error" },
        time: 3000,
      }),
    );
  }
}

export function* userServiceConnected() {
  try {
    const response = yield axiosApi.get("/api/users/timeoutCheck");
    yield put(SuccessUserServiceConnected());
  } catch (error) {
    yield put(FailureUserServiceConnected());
  }
}

export function* checkExistingResponsibles() {
  try {
    const response = yield call(axiosApi.get, "/api/containers/check-existing-responsibles");
    yield put(SuccessCheckExistingResponsibles(response.data));
  } catch (error) {
    yield put(FailureCheckExistingResponsibles());
  }
}

const containerSagas = [
  takeLatest(RequestContainerService, containerService),
  takeLatest(RequestLiveResponsibles, liveResponsibles),
  takeLatest(RequestContainerServices, containerServices),
  takeLatest(RequestInforService, inforService),
  takeLatest(RequestVirshService, virshService),
  takeLatest(RequestPodUpdate, podUpdate),
  takeLatest(RequestPodRestart, podRestart),
  takeLatest(RequestGetAutoUpdateState, getAutoUpdateState),
  takeLatest(RequestSetAutoUpdateState, setAutoUpdateState),
  takeLatest(RequestBackendServiceConnected, backendServiceConnected),
  takeLatest(RequestUserServiceConnected, userServiceConnected),
  takeLatest(RequestCheckExistingResponsibles, checkExistingResponsibles),
];

export default containerSagas;
